var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.75977V11.4264C14.6667 11.8685 14.4911 12.2924 14.1785 12.6049C13.866 12.9175 13.442 13.0931 13 13.0931H3.00001C2.55798 13.0931 2.13406 12.9175 1.8215 12.6049C1.50894 12.2924 1.33334 11.8685 1.33334 11.4264V4.75977",
    stroke: "#5E5E5E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.75968C14.6667 4.31766 14.4911 3.89373 14.1785 3.58117C13.866 3.26861 13.442 3.09302 13 3.09302H3.00001C2.55798 3.09302 2.13406 3.26861 1.8215 3.58117C1.50894 3.89373 1.33334 4.31766 1.33334 4.75968L7.11668 8.3708C7.38156 8.53635 7.68764 8.62413 8.00001 8.62413C8.31238 8.62413 8.61846 8.53635 8.88334 8.3708L14.6667 4.75968Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.23a462011911951b1fc02b9e01cba9e0.svg";
export { ForwardRef as ReactComponent };